import fetch from 'node-fetch';

const deleteOrigin = async (token: string, distributionName: string, originId: string) => {
    const response = await fetch(`${process.env.REACT_APP_ADN_MANAGEMENT_BASE_URL}/v1/distributions/${distributionName}/origins/${originId}`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    if (!response.ok) {
        throw new Error(`Failed to delete origin. Received status code ${response.status}`);
    }
};

export default deleteOrigin;
